export default __webpack_public_path__ + "static/media/os1.649247c6.png";